var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.803,
    height: 13.605,
    viewBox: "0 0 7.803 13.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_87",
    "data-name": "Raggruppa 87",
    transform: "translate(-11.991 -6.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_955",
    "data-name": "Tracciato 955",
    d: "M-7409.029,12492.533l-5.388,5.389,5.388,5.389",
    transform: "translate(7427.408 -12484.365)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.d2b508799f25f288b90bff6587a50be7.svg";
export { ForwardRef as ReactComponent };